const RECEIVE_OMNI_SEGMENT_DATA = 'src/omniSegmentList/RECEIVE_OMNI_SEGMENT_DATA' as const;
const START_FETCH = 'src/omniSegmentList/START_FETCH' as const;
const END_FETCH = 'src/omniSegmentList/EMD_FETCH' as const;

export default { RECEIVE_OMNI_SEGMENT_DATA, START_FETCH, END_FETCH };
